import { render, staticRenderFns } from "./KeyDatesDialog.vue?vue&type=template&id=3a056666&scoped=true"
import script from "./KeyDatesDialog.vue?vue&type=script&lang=js"
export * from "./KeyDatesDialog.vue?vue&type=script&lang=js"
import style0 from "./KeyDatesDialog.vue?vue&type=style&index=0&id=3a056666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a056666",
  null
  
)

export default component.exports